export default __webpack_public_path__ + "static/media/D1996_08_18_Buenos_Aires_White_Cells.acf608c9.jpg";